import { reqClaimFormDetail } from '@/routes/InvoiceList/services';
import { deleteInvoice, getInvoiceDetail } from '@/routes/Note/services';
import {
  editDeductionTax,
  getExportResult,
  getInvoiceRule,
  getUnitInvoiceList,
  invoiceExport,
  saveInvoiceRule,
} from '../services';

export default {
  namespace: 'invoiceList',
  state: {},
  effects: {
    // 条件查询单位票池列表
    *getUnitInvoiceList({ payload }, { call }) {
      return yield call(getUnitInvoiceList, payload);
    },

    // 查看票据详情
    *getInvoiceDetail({ payload }, { call }) {
      return yield call(getInvoiceDetail, payload);
    },

    // 获取报销单详情
    *getClaimInfo({ payload }, { call }) {
      return yield call(reqClaimFormDetail, payload);
    },

    // 获取用户三方票据拉取规则
    *getInvoiceRule({ payload }, { call }) {
      return yield call(getInvoiceRule, payload);
    },

    // 保存/更新三方票据拉取规则
    *saveInvoiceRule({ payload }, { call }) {
      return yield call(saveInvoiceRule, payload);
    },

    // 更新进项税
    *editDeductionTax({ payload }, { call }) {
      return yield call(editDeductionTax, payload);
    },

    // 删除票据
    *deleteInvoice({ payload }, { call }) {
      return yield call(deleteInvoice, payload);
    },

    // 票据excel导出
    *invoiceExport({ payload }, { call }) {
      return yield call(invoiceExport, payload);
    },

    // 导出任务结果
    *getExportResult({ payload }, { call }) {
      return yield call(getExportResult, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
